import Hls from 'hls.js';
import React, { useEffect, useRef, useState } from 'react';
interface EventVideoRecordingPlayerProps {
  src: string;
  autoPlay?: boolean;
  controls?: boolean;
  width?: string | number;
  height?: string | number;
  thumbnail?: string;
}

export const EventVideoRecordingPlayer: React.FC<EventVideoRecordingPlayerProps> = ({
  src,
  autoPlay = false, // updated to false so user can click play
  controls = true,
  width = '100%',
  height = 'auto',
  thumbnail = 'https://images.pexels.com/photos/3376799/pexels-photo-3376799.jpeg',
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(autoPlay);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, function (event, data) {
        console.error('HLS error:', data);
      });

      return () => {
        hls.destroy();
      };
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
    } else {
      console.error('This browser does not support HLS playback.');
    }
  }, [src]);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoPlay = () => setIsPlaying(true);
  const handleVideoPause = () => setIsPlaying(false);

  return (
    <div className="rounded-xl overflow-hidden" style={{ position: 'relative', width, height }}>
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        controls={controls}
        autoPlay={autoPlay}
        poster={thumbnail}
        style={{ objectFit: 'cover' }}
        onPlay={handleVideoPlay}
        onPause={handleVideoPause}
      />
      {!isPlaying && (
        <div
          onClick={handlePlay}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <svg width="80" height="80" viewBox="0 0 64 64" fill="#fff" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 12 L52 32 L16 52 Z" />
          </svg>
        </div>
      )}
    </div>
  );
};
